import { Archive } from "@mui/icons-material";
import { Divider, ListItemIcon, MenuItem } from "@mui/material";
import React from "react";


export default function KanbanCarkArquivarMenu(props) {
    const {action} = props;

    function handleClick(){
        if( action ) action();
    }

    return (
        <React.Fragment>
            <Divider />
            <MenuItem onClick={handleClick}>
                <ListItemIcon size='small'>
                    <Archive fontSize="small" />
                </ListItemIcon>
                Arquivar
            </MenuItem>

        </React.Fragment>

    )
}